import {Route} from "../../../common/enums/route";
import OrganizationSettingsCan from "../../organization_settings/ability/organizationSettingsCan";
import OrganizationManagementCan from "../../organization_management/ability/organizationManagementCan";
import DocumentManagementCan from "../../document_management/ability/documentManagementCan";
import * as _ from "lodash";

export function findSelectedConfigsFromRoute(route: Route, currentConfig) {
  if (currentConfig.route === route) {
    return [currentConfig];
  } else if (currentConfig.children) {
    let childPath = null;

    currentConfig.children.forEach(function (childConfig) {
      childPath = childPath || findSelectedConfigsFromRoute(route, childConfig);
    });

    if (childPath) {
      return [currentConfig, ...childPath]
    } else {
      return null;
    }
  } else {
    return null;
  }
}

// be careful not to mutate the 'hardcoded' config
export function configForUser(config, state) {
  if (!state.user || !state.organization) {
    return null;
  }


  if (config.requiredPermission && !hasRequiredPermission(config.requiredPermission, {user: state.user, organization: state.organization})) {
    return null;
  }

  const userConfig = _.clone(config); // intentionally shallow

  let children = config.children;
  if (children) {
    children = _.map(config.children, function(childConfig) {
      return configForUser(childConfig, state);
    });

    children = _.compact(children);

    if (children.length > 0) {
      userConfig.children = children;
    } else {
      delete userConfig.children;
    }
  }

  if (!userConfig.children && (!userConfig.route && !userConfig.textInput)) {
    return null;
  } else {
    return userConfig;
  }
}

export function configsToSelectViaDefaults(config) {
  return [config, ...childConfigsToSelectViaDefaults(config)];
}

const childConfigsToSelectViaDefaults = function (config) {
  let configsToSelect = [];

  if (config.children) {
    const defaultChild = config.children.find((c) => c.default);

    if (defaultChild) {
      configsToSelect = [defaultChild, ...childConfigsToSelectViaDefaults(defaultChild)];
    }
  }

  return configsToSelect;
}

const _cans = [];
const getCans = function (user) {
  if (_cans.length === 0) {
    [OrganizationManagementCan, OrganizationSettingsCan, DocumentManagementCan].forEach(function (canClass) {
      const can = new canClass(user);
      _cans.push(can.can.bind(can));
    });
  }

  return _cans;
};

const hasRequiredPermission = function(requiredPermission, {user, organization}) {
  const cans = getCans(user);

  let obj;
  switch (requiredPermission.param) {
    case 'user':
      obj = user;
      break;
    case 'organization':
      obj = organization;
      break;
  }

  return cans.some(function (can) {
    return can(requiredPermission.name, obj);
  });
};

